module.exports = __webpack_public_path__ + "static/img/logo.bcf342d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/role/logo.png
// module id = +13L
// module chunks = 0